import { render, staticRenderFns } from "./thai-add.vue?vue&type=template&id=1f947f06&"
import script from "./thai-add.vue?vue&type=script&lang=js&"
export * from "./thai-add.vue?vue&type=script&lang=js&"
import style0 from "./thai-add.vue?vue&type=style&index=0&id=1f947f06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports